/*  required imports */
import Hero from "../components/Hero";
import Navbar from "../components/Navbar";
import Thoughts from "../components/Thoughts";
import Footer from "../components/Footer";

/* 
hero button is currently off
can change by turning the Hero component> btnClass from "hide" to "show" in src/pages/Ideas.js
*/


function Ideas() {

  return (
    <div>
      <Navbar/>
      <Hero 
        title="Ideas"
        subtitle="Articles, essays, opinions, and more."
        backgroundColor={"#bdbdbd"}
        url="https://matthewpkearney.medium.com"  //  '/projects' if not
        btnClass={"show"}
        buttonText={"Medium"} /* when content expands */
      />
      <Thoughts/>
      <Footer/>  
    </div>
  );
}
  
export default Ideas;